import { useAtomValue } from 'jotai';
import { openFloatingChat } from '@fiverr-private/go_floating_chat_triggers';
import { floatingChatDataAtom } from '@fiverr-private/seller_pages_toolbox';
import { useFreelancerPageContext } from '../../FreelancerPageContext';

export const useFloatingChatTrigger = () => {
    const { isOnline, seller } = useFreelancerPageContext();
    const { isFloatingChatEnabled, showConversationSavedTooltip } = useAtomValue(floatingChatDataAtom);
    const username = seller?.user?.name;
    const displayName = seller?.user?.profile?.displayName || username;
    const profileImageUrl = seller?.user?.profileImageUrl;
    const sellerId = seller?.user?.id || '';

    return {
        isFloatingChatEnabled,
        openFloatingChat: () =>
            openFloatingChat({
                data: {
                    recipientUsername: username,
                    showConversationSavedTooltip,
                    seller: {
                        username,
                        name: displayName,
                        imageSrc: profileImageUrl,
                        isOnline,
                    },
                    initialData: {
                        sellerId,
                        entryPoint: 'seller',
                    },
                },
            }),
    };
};
